export const fetchInstagramPosts = async () => {
  // Simüle edilmiş Instagram post verileri
  const posts = [
    {
      id: "1",
      media_url: "/images/instagram/bowling.jpg",
      caption: "DPÜ SET Oyun Gecesi 🎳 Eğlence dolu anlar! #DpuSet #Bowling",
      permalink: "https://instagram.com/dpuset",
      timestamp: "2024-03-15T15:00:00Z",
      likes: 156,
      comments: 23
    },
    {
      id: "2",
      media_url: "/images/instagram/mangal.jpg",
      caption: "Mangal Etkinliği! #DpuSet #mangal",
      permalink: "https://instagram.com/dpuset",
      timestamp: "2024-03-10T13:30:00Z",
      likes: 142,
      comments: 18
    },
    {
      id: "3",
      media_url: "/images/instagram/ankara.jpg",
      caption: "Ankara Gezisi! #DpuSet #ankara",
      permalink: "https://instagram.com/dpuset",
      timestamp: "2024-03-10T13:30:00Z",
      likes: 189,
      comments: 27
    }
  ];

  return Promise.resolve(posts);
}; 
